// @flow

import type { Action } from '../types/actions/appupdate'

export const APP_UPDATE_AVAILABLE = 'APP_UPDATE_AVAILABLE'

export function setUserNeedsAppUpdate () : Action {
  return {
    type: APP_UPDATE_AVAILABLE
  }
}
